import React from "react";
import { Link } from "react-router-dom";

const NavItem = ({ to, text, onClick, isActive }) => {
  const baseClasses =
    "block px-3 py-2 rounded lg:px-6 md:p-0 font-bold text-gray-700";
  const activeClasses =
    "text-white bg-blue-700 md:bg-transparent md:text-blue-700 md:dark:text-blue-500";
  const inactiveClasses =
    "text-gray-900 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700";

  return (
    <li>
      <Link
        to={to}
        className={`${baseClasses} ${
          isActive ? activeClasses : inactiveClasses
        }`}
        onClick={onClick}
        aria-current={isActive ? "page" : undefined}
      >
        {text}
      </Link>
    </li>
  );
};

export default NavItem;
